var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toolbar-item"},[_vm._v(" "+_vm._s(_vm.label)+": "),_c('div',{staticClass:"value-wrap"},[_vm._t("value",function(){return [_vm._v(" "+_vm._s(_vm.value)+" ")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }